import React, { Component } from "react";
import "./OwObjectChips.scss";
import ContextEnum from "../../../models/ContextEnum";
import ChipSizeEnum from "../OwChips/ChipSizeEnum";

type Props = {
    chips: any[];
    removeChip: (chipObject: any, index: number) => void;
    context?: ContextEnum;
    chipSize?: ChipSizeEnum;
    isPill?: boolean;
    isStacked?: boolean;
    titleProp: string;
    subTitleProp?: string;
};

type State = {};

export default class OwObjectChips extends Component<Props, State> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render() {
        let context = "";

        if (this.props.context) {
            context = `badge-${this.props.context}`;
        }

        let pillContext = "";

        if (this.props.isPill) {
            pillContext = "badge-pill";
        }

        let flexType = "d-inline-flex";

        if (this.props.isStacked) {
            flexType = "";
        }

        let ChipTag: any = "div";

        if (this.props.chipSize) {
            ChipTag = this.props.chipSize;
        }

        return (
            <div className="OwObjectChips">
                {this.props.chips.map((chip, index: number) => {
                    const deleteIcon = (
                        <div
                            className={"ms-2 pointer"}
                            onClick={(e: any) => {
                                this.props.removeChip(chip, index);
                            }}>
                            <i className={"fas fa-times-circle"}></i>
                        </div>
                    );

                    const title = chip[this.props.titleProp];

                    const subTitle = this.props.subTitleProp ? chip[this.props.subTitleProp] : null;

                    return (
                        <ChipTag className={`${flexType}`} key={chip}>
                            <div>
                                <div className={`badge ${context} ${pillContext} d-inline-flex align-items-center text-start`}>
                                    <div>
                                        <div>{title}</div>
                                        <div>{subTitle}</div>
                                    </div>{" "}
                                    {deleteIcon}
                                </div>
                            </div>
                        </ChipTag>
                    );
                })}
            </div>
        );
    }
}
